export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/report/query`,
          data
        });
      },
      list(data){
          return http.json({
              url: `/report/list`,
              data
          });
      },
      getReportInfo(data){
        return http.json({
            url: `/report/get?id=${data.id}`,
            data
        });
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/report.js